import script from "./Accounts.vue?vue&type=script&setup=true&lang=ts"
export * from "./Accounts.vue?vue&type=script&setup=true&lang=ts"

import "./Accounts.vue?vue&type=style&index=0&id=38f9e708&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38f9e708"]])

export default __exports__